import React from 'react';
import Select from '~f/Select';
import routes, { server } from '~/apiRouter';
import messages from '~h/messages';
import Loader, { spinnerStates, spinnerPositions } from '~c/ui/Loader';

const UPLOAD_BY_DEVICE = 'UPLOAD_BY_DEVICE';
const UPLOAD_BY_LINK = 'UPLOAD_BY_LINK';

/**
 * @description Component, what can pick an image from file or url
 * TODO: надо отрефакторить, запутанная логика на тернарниках, тяжело читается. хорошо бы разбить на подкомпоненты в зависимости от типа загрузки файла.
 *
 * @param {string} value string
 * @param {string} label string
 * @callback onChange(value) Returns path to image as value
 *
 * @usage <Image />
 */
class Image extends React.Component {
  state = {
    uploadBy: UPLOAD_BY_DEVICE,
    fileURL: '',
    file: null,
    spinnerState: spinnerStates.done,
    errorMessage: '',
    loaded: false,
  };

  componentDidMount() {
    const { value } = this.props;
    if (value) {
      this.setState({
        fileURL: value,
        loaded: true,
      });
    }
  }

  uploadImage = () => {
    this.setState({ spinnerState: spinnerStates.pending, errorMessage: '' });

    if (this.state.fileURL === '') {
      this.setState({
        spinnerState: spinnerStates.error,
        errorMessage: messages.fileIsEmpty,
      });
      return;
    }

    // FIXE: should cookies be inline?
    // const cookie =
    //   'PHPSESSID=17b3ce69f2f7d7ff7c6a8481bdc28c56; BITRIX_SM_CITY_SELECTED=samara1223; BITRIX_SM_SOUND_LOGIN_PLAYED=Y; BITRIX_SM_UIDH=68d67cf518a72b1a80188fc244e94131; BITRIX_SM_UIDL=%252B79277581813; BITRIX_SM_LOGIN=%252B79277581813';

    // default fetch optipns
    const options = {
      method: 'POST',
      headers: {
        // cookie,
      },
      credentials: 'include',
    };

    // add special fields to options, depends on upload type
    switch (this.state.uploadBy) {
      case UPLOAD_BY_DEVICE: {
        const formData = new FormData();
        formData.append('file', this.state.file);
        options.body = formData;
        break;
      }
      case UPLOAD_BY_LINK: {
        options.body = JSON.stringify({
          file: this.state.fileURL,
        });
        options.headers['content-type'] = 'application/json';
        break;
      }
      default:
        break;
    }

    // FIXME: find event.id
    // {{ base_uri  }}event/designer/{{ event.id  }}/image

    const eventId = $('#page-editor').data('page');
    const url = this.props.fetchURL
      ? this.props.fetchURL
      : `${routes.designer.get}${eventId}/image`;
    fetch(url, options)
      .then(response => {
        return response.json();
      })
      .then(json => {
        try {
          if (json.status === 'success') {
            const path =
              process.env.NODE_ENV === 'development'
                ? `${server}${json.data.FILE.PATH}`
                : json.data.FILE.PATH;
            this.props.onChange(path);
            this.setState({
              spinnerState: spinnerStates.done,
              loaded: true,
              fileURL: path,
            });
          }
          if (json.status === 'error') {
            this.setState({
              spinnerState: spinnerStates.error,
              errorMessage: json.errors[0].message,
            });
          }
        } catch (err) {
          this.setState({
            spinnerState: spinnerStates.error,
            errorMessage: messages.unknownError,
          });
        }
      })
      .catch(err => {
        this.setState({
          spinnerState: spinnerStates.error,
          errorMessage: messages.serverTimeout,
        });
      });
  };

  removeFile(e) {
    e.stopPropagation();
    this.props.onChange('');
    this.setState({
      file: null,
      fileURL: '',
      errorMessage: '',
      loaded: false,
      spinnerState: spinnerStates.done,
    });
  }

  render() {
    // delete / upload buttons
    const deleteBtn = (
      <button
        className="inp__field--wrapper-del"
        onClick={e => this.removeFile(e)}
      >
        <span></span>
      </button>
    );
    const uploadBtn = (
      <React.Fragment>
        <button
          className="btn btn--action"
          disabled={this.state.loaded}
          // {this.state.loaded} ? disabled : null
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            this.uploadImage();
          }}
        >
          Загрузить
          <Loader
            spinnerState={this.state.spinnerState}
            spinnerPosition={spinnerPositions.absolute}
            style={{ right: '20px' }}
          />
        </button>
      </React.Fragment>
    );

    // main input for file / file url
    const uploadByStr =
      this.state.uploadBy === UPLOAD_BY_DEVICE ? (
        // if url to file is empty, draw only button/input-file
        this.state.fileURL == '' ? (
          <React.Fragment>
            <label htmlFor="fileInput" className="btn btn--action">
              Выбрать файл
            </label>
            <input autoComplete="off"
              type="file"
              accept="image/png, image/jpeg, image/gif, image/bmp"
              id="fileInput"
              className="hidden"
              value={this.state.fileURL}
              onChange={e => {
                this.setState({
                  fileURL: e.target.files[0].name,
                  file: e.target.files[0],
                });
              }}
            />
          </React.Fragment>
        ) : (
          // if file selected, draw file url as input
          <React.Fragment>
            <label className="inp__field--wrapper inp__field--withMargin">
              <p className="inp__label">файл</p>
              <input autoComplete="off"
                className="inp__field"
                disabled
                type="text"
                value={this.state.fileURL}
                onChange={e => {
                  this.setState({ fileURL: e.target.value });
                }}
              />
              {deleteBtn}
            </label>
            {uploadBtn}
          </React.Fragment>
        )
      ) : (
        // if selected upload from url, draw file input url
        <React.Fragment>
          <div className="inp__field--wrapper inp__field--withMargin">
            <p className="inp__label">файл</p>
            <input autoComplete="off"
              className="inp__field inp__field--close"
              type="text"
              value={this.state.fileURL}
              onChange={e => this.setState({ fileURL: e.target.value })}
            />
            {deleteBtn}
          </div>
          {uploadBtn}
        </React.Fragment>
      );
    return (
      <React.Fragment>
        <div className="form-group__image-input">
          <label className="inp">
            <p className="inp__label">Превью</p>
            <Select
              value={this.state.uploadBy}
              onChange={value =>
                this.setState({
                  uploadBy: value,
                  errorMessage: '',
                  fileURL: '',
                  spinnerState: spinnerStates.done,
                  loaded: false,
                })
              }
              options={[
                { value: UPLOAD_BY_DEVICE, label: 'С устройства' },
                { value: UPLOAD_BY_LINK, label: 'По ссылке' },
              ]}
            />
          </label>
          {uploadByStr}
        </div>
        {this.state.errorMessage !== '' ? (
          <p className="txt txt--red">{this.state.errorMessage}</p>
        ) : null}
      </React.Fragment>
    );
  }
}

Image.defaultProps = {
  onChange: () => {},
  fetchURL: null,
};

export default Image;
